const RawMaterialPurposeEnum = Object.freeze({
  Packing: 'Packing',
  // Production: 'Production',
});

export default RawMaterialPurposeEnum;
